import EstadosJuicio from "../domain/EstadosJuicio"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class EstadosJuicioService {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async getEstadosJuicios() {
    const estadosData = await this.apiService.fetchEstadosJuicios()

    const listadoEstados= estadosData.juiciosEstados.map( 
      (estado) => 
        new EstadosJuicio(
          estado.key,
          estado.value
        )
    )

    return listadoEstados
  }
}

export default EstadosJuicioService
